import "../../App/App.css";
const Registro = () => {
  return (
    <div>
      <h1 className="registro">Registro</h1>
    </div>
  );
};
export default Registro;
